import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal,
  TextField,
  useTheme,
  Grid,
  Avatar,
  Paper,
} from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import ModalContent from "../../Common/Modal";
import { useSelector } from "react-redux";
import { ContainedButton } from "../../Common/Buttons";

const TraderProfile = ({
  traderRole,
  themeMode,
  onThemeChange,
  subscriptionPrice,
  onSubscribe,
}) => {
  const { btncolor } = useSelector((state) => state);
  const navigate = useNavigate();
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);
  const theme = useTheme();
  const isDark = themeMode === "Dark";

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  console.log("idlsjs", id, type);

  const [traderDetails, setTraderDetails] = useState(null);

  const getTraderDetails = () => {
    const updateAPI = {
      id: id,
      isBotOrApi: type,
      customerId: localStorage.getItem("userId"),
    };

    axios
      .post(
        "https://accounts.paybito.com/api/copyTrading/marketPlace/GetViewTraderDtls",
        JSON.stringify(updateAPI),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const res = response.data;
        setTraderDetails(res.traderDtls[0]);

        // Uncomment if you want to handle error flags
        // if (res.error.error_data === '0') {
        //   // success logic
        // } else {
        //   alert(res.error.error_msg);
        // }
      })
      .catch((error) => {
        console.error("Error fetching trader details:", error);
      });
  };

  useEffect(() => {
    getTraderDetails();
  }, [id, type]); // Runs again if apiId or type changes

  const handleOpenModal = () => setSubscriptionOpen(true);
  const handleCloseModal = () => setSubscriptionOpen(false);

  return (
    <Box sx={{ paddingLeft: 3, paddingTop: 0 }}>
      <Grid container spacing={2} mt={3} px={{ xs: 2, md: 0 }}>
        <Grid
          size={{ xs: 12, md: 12 }}
          display={"flex"}
          justifyContent={"flex-end"}
        >
          <ContainedButton
            variant="contained"
            startIcon={
              <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
            }
            onClick={() => navigate("/marketplace")}
          >
            Back
          </ContainedButton>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ height: "250px" }}>
            <Box display="flex" justifyContent="space-between">
              <Box>
                <Box p={1} className="d-flex">
                  <Typography
                    variant="subtitle2"
                    className="text-secondary px-2"
                  >
                    Trader Name
                  </Typography>
                  <Typography variant="subtitle2">
                    {traderDetails?.traderName}
                  </Typography>
                </Box>
                <Box p={1} className="d-flex">
                  <Typography
                    variant="subtitle2"
                    className="text-secondary px-2"
                  >
                    Followers:
                  </Typography>
                  <Typography variant="subtitle2">
                    {traderDetails?.followers}
                  </Typography>
                </Box>
                <Box p={1} className="d-flex">
                  <Typography
                    variant="subtitle2"
                    className="text-secondary px-2"
                  >
                    Market:
                  </Typography>
                  <Typography variant="subtitle2">
                    {traderDetails?.market}
                  </Typography>
                </Box>
                <Box p={1} className="d-flex">
                  <Typography
                    variant="subtitle2"
                    className="text-secondary px-2"
                  >
                    Minimum Capital Requirement:
                  </Typography>
                  <Typography variant="subtitle2">
                    USDT {traderDetails?.minimumCapitalRequirement}
                  </Typography>
                </Box>
              </Box>

              <button
                className="imgBtn btn btn-secondary allCommonButton"
                style={{ marginRight: "10px", marginTop: "10px" }}
              >
                <img
                  src={
                    traderDetails?.profileLink ??
                    "https://i.imgur.com/wvxPV9S.png"
                  }
                  height="100"
                  width="100"
                />
              </button>
            </Box>
          </Paper>
          {traderDetails?.isFollowed === "2" && (
            <ContainedButton
              sx={{ mt: 2 }}
              variant="contained"
              disabled={
                traderRole !== "copyTrader" ||
                traderDetails?.allowCopyTrading === "0"
              }
              onClick={handleOpenModal}
            >
              Follow Trader
            </ContainedButton>
          )}

          {traderDetails?.isFollowed === "1" && (
            <ContainedButton sx={{ mt: 2 }} variant="contained" disabled>
              Following
            </ContainedButton>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Paper sx={{ height: "250px" }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>All Time</TableCell>
                  <TableCell>Month</TableCell>
                  <TableCell>Week</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>P/L</TableCell>
                  <TableCell>{traderDetails?.pnlOfAllTime}</TableCell>
                  <TableCell>{traderDetails?.pnlOfMonth}</TableCell>
                  <TableCell>{traderDetails?.pnlOfWeek}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Volume</TableCell>
                  <TableCell>{traderDetails?.volOfAllTime}</TableCell>
                  <TableCell>{traderDetails?.volOfMonth}</TableCell>
                  <TableCell>{traderDetails?.volOfWeek}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Number Of Trades</TableCell>
                  <TableCell>{traderDetails?.numOfTradesOfAllTime}</TableCell>
                  <TableCell>{traderDetails?.numOfTradesOfMonth}</TableCell>
                  <TableCell>{traderDetails?.numOfTradesOfWeek}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>

      {/* Subscription Modal */}

      <ModalContent
        open={subscriptionOpen}
        onClose={handleCloseModal}
        title={`Subscription info`}
      >
        <TextField
          label="Price"
          fullWidth
          margin="normal"
          value={`${subscriptionPrice} USDT/mo`}
          InputProps={{ readOnly: true }}
        />
        <TextField
          label="Period"
          fullWidth
          margin="normal"
          value="30 days"
          InputProps={{ readOnly: true }}
        />
        <ContainedButton
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => {
            onSubscribe();
            handleCloseModal();
          }}
          fullWidth
        >
          Subscribe
        </ContainedButton>
      </ModalContent>
    </Box>
  );
};

export default TraderProfile;
